var React = require('react');

function ArrowCircleLg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M45.0387 23C45.0387 10.9616 35.2796 1.20258 23.2413 1.20258C11.2029 1.20258 1.44385 10.9616 1.44385 23C1.44385 35.0384 11.2029 44.7974 23.2413 44.7974C35.2796 44.7974 45.0387 35.0384 45.0387 23Z","fill":"white","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M23.3865 13.2502L23.606 32.7501","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M17.7307 18.6184L23.3865 13.2502","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M28.7547 18.906L23.3865 13.2502","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

ArrowCircleLg.defaultProps = {"viewBox":"0 0 46 46","fill":"none"};

module.exports = ArrowCircleLg;

ArrowCircleLg.default = ArrowCircleLg;
